import React from 'react';
import styled from 'styled-components';
import MobileButtonsListItem from './mobile-buttons-list-item/mobile-buttons-list-item.container';
import { PORTAL_TYPE } from '../../../types/app.types';
import { ButtonListDataItem } from '../buttons-list.data';
import styleUtils from '../../../styles/style.utils';
import mediaBreakpoints from '../../../styles/media-breakpoints';

interface MobileButtonsListContentProps {
  items: ButtonListDataItem[];
  activeItem?: PORTAL_TYPE | null;
  toggleButton: (id: PORTAL_TYPE) => void;
}

const MobileButtonsListContent: React.FunctionComponent<MobileButtonsListContentProps> = ({
  items,
  toggleButton,
  activeItem
}) => {
  return (
    <Container>
      {items.map((item) => (
        <MobileButtonsListItem
          key={`mobile-button-${item.id}`}
          item={item}
          toggleButton={toggleButton}
          isActive={item.id === activeItem}
        />
      ))}
    </Container>
  );
};

const Container = styled.div`
  max-width: 100%;
  padding: ${styleUtils.px(20)} 0;

  ${mediaBreakpoints.greaterThan('XS')`
  padding: ${styleUtils.px(36)};
  `};
`;

export default MobileButtonsListContent;
